import React from "react";
import { Route, Routes, useLocation, Location } from "react-router-dom";
import { CreateQuestion, Layout, Modal, SignInForm, SignUpForm } from "./components";
import { About, ErrorPage, FollowList, Home, Notifications, Privacy, Profile, Question, Terms, UserBookmarks, UserQuestions, SearchQuestions, Soulmates, Welcome } from "./pages";

interface LocationState {
  backgroundLocation?: Location;
}

export const RouterPaths: React.FC = () => {

  const location = useLocation();

  // The `backgroundLocation` state is the location that we were at when one of
  // the gallery links was clicked. If it's there, use it as the location for
  // the <Routes> so we show the gallery in the background, behind the modal.
  const state: LocationState = location.state || {};

  return (
    <>
      <Routes location={state.backgroundLocation || location}>
        <Route path="/" element={<Layout />} errorElement={<ErrorPage />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Modal navigateTo={'/'}><SignInForm /></Modal>} />
          <Route path="/register" element={<Modal navigateTo={'/'}><SignUpForm /></Modal>} />
          <Route path="/create-pinion" element={<Modal navigateTo={'/'}><CreateQuestion /></Modal>} />
          <Route path="/profile/:userId" element={<Profile />} />
          <Route path="/profile/:userId/followers" element={<FollowList type="followers" />} />
          <Route path="/profile/:userId/following" element={<FollowList type="following" />} />
          <Route path="/bookmarks" element={<UserBookmarks />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/soulmates" element={<Soulmates />} />
          <Route path="/question/:questionId" element={<Question />} />
          <Route path="/user-questions/:userId" element={<UserQuestions />} />
          <Route path="/search-questions/:title" element={<SearchQuestions />} />
        </Route>
        {/* Full-screen post-signup onboarding takeover. Deliberately OUTSIDE
            Layout: Layout renders both the desktop and mobile panes at once
            (CSS-toggled), so a route nested in it mounts twice with independent
            state — crossing the breakpoint mid-quiz would reveal a second quiz
            back at question 1. Top-level, it mounts exactly once.
            The wrapper restores a scroll region: `body` is 100dvh/overflow-hidden
            and Layout's own scroll containers don't apply here, so without this a
            long question or short landscape viewport could push the Yes/No
            buttons off-screen with no way to reach them. */}
        <Route
          path="/welcome"
          element={
            <div className="h-[100dvh] w-full overflow-y-auto">
              <Welcome />
            </div>
          }
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes >

      {/* Show the modal when a `backgroundLocation` is set */}
      {
        state.backgroundLocation && (
          <Routes>
            <Route path="/login" element={<Modal navigateTo={-1}><SignInForm /></Modal>} />
            <Route path="/register" element={<Modal navigateTo={-1}><SignUpForm /></Modal>} />
            <Route path="/create-pinion" element={<Modal navigateTo={-1}><CreateQuestion /></Modal>} />
          </Routes>
        )
      }
    </>
  );
};